import { render } from "./locale-button.vue?vue&type=template&id=12116372&scoped=true"
import script from "./locale-button.vue?vue&type=script&lang=js"
export * from "./locale-button.vue?vue&type=script&lang=js"

import "./locale-button.vue?vue&type=style&index=0&id=12116372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12116372"]])

export default __exports__